
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"currentColor","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"currentColor","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2063.193-1773.154h-.966v-1.9a4.841 4.841 0 10-9.683 0v1.9h-.965a2.082 2.082 0 00-2.08 2.08v8.891a2.082 2.082 0 002.08 2.08h11.614a2.082 2.082 0 002.08-2.08v-8.891a2.082 2.082 0 00-2.08-2.08zm-9.089-1.9a3.282 3.282 0 016.564 0v1.9h-6.564zm9.609 12.87a.52.52 0 01-.52.52h-11.614a.52.52 0 01-.52-.52v-8.89a.52.52 0 01.52-.52h.966v2.814h1.56v-2.814h6.564v2.814h1.56v-2.814h.966a.52.52 0 01.52.52z"}})])])
          )
        }
      }
    